import UserStream from "discourse/components/user-stream";

export default <template><UserStream @stream={{@controller.model}} /></template>
